module.exports = new Promise((resolve, reject) => {
    const urlParams = new URLSearchParams(window.location.search);
    let remoteUrlWithVersionMA;
    let cookies = document.cookie;
    const cookieArray = cookies.split(";").map((s) => s.split("=").map((s) => s.trim())).reduce((m, [k, v]) => (m.set(k, v), m), new Map());
    const env = cookieArray.get("VANTAGE_ENV");
    // console.log("environent ", env);
    switch (env) {
        case "local":
            remoteUrlWithVersionMA = "http://localhost:3000/remoteEntry.js";
            break;
        case "dev":
            remoteUrlWithVersionMA =
                "https://vantagedevma.exlservice.com/remoteEntry.js";
            break;
        case "TestAzure":
        case "cexltest":
            remoteUrlWithVersionMA =
                "https://vantagetestma.exlservice.com/remoteEntry.js";
            break;
        case "TWNP":
            remoteUrlWithVersionMA =
                "https://vmacommonnp3.triwest.com/remoteEntry.js";
            break;
        case "TWSTG":
            remoteUrlWithVersionMA =
                "https://vmacommonstg.triwest.com/remoteEntry.js";
            break;
        case "TWPRD":
            remoteUrlWithVersionMA =
                "https://VantageMA.triwest.com/remoteEntry.js";
            break;
        case "qa":
            remoteUrlWithVersionMA =
                "https://qa-exlvantage-ma.exlservice.com/remoteEntry.js";
            break;
        case "hznuat":
        case "demouat":
        case "hpuat":
            remoteUrlWithVersionMA = "https://vantageuatma.exlservice.com/remoteEntry.js";
            break;
        case "hznprod":
        case "hpprod":
        case "chaprod":
            remoteUrlWithVersionMA = "https://vantageprodma.exlservice.com/remoteEntry.js";
            break;
        case "chadr":
        case "chadrtest":
        case "hzndr":
        case "hzndrtest":
            remoteUrlWithVersionMA = "https://vantagedrma.exlservice.com/remoteEntry.js";
            break;
        case "hpdr":
        case "hpdrtest":
            remoteUrlWithVersionMA = "https://vantagedrma.exlservice.com/remoteEntry.js";
            break;            
        case "idemo":
            remoteUrlWithVersionMA = "http://localhost:3000/remoteEntry.js";
            break;
        case "test":
            remoteUrlWithVersionMA =
                "https://testma-infolock.lockton.com/remoteEntry.js";
            break;
        case "Prod":
            remoteUrlWithVersionMA = "https://ma-infolock.lockton.com/remoteEntry.js";
            break;
        case "DR":
            remoteUrlWithVersionMA = "https://proddr-ma-infolock.lockton.com/remoteEntry.js";
            break;
        case "DRPROD":
            remoteUrlWithVersionMA = "https://proddr-ma-infolock.lockton.com/remoteEntry.js";
            break;
        default:
            remoteUrlWithVersionMA = "";
            break;
    }

    // Redirect to Login Page 
    if (remoteUrlWithVersionMA === undefined) {
        //debugger
        let MVCLoginURL;
        let domain = new URL(window.location.origin);
        switch (domain.host) {
            case "devhome-infolock.lockton.com":
                MVCLoginURL = "https://dev-infolock.lockton.com";
                break;
            case "testhome-infolock.lockton.com":
                MVCLoginURL = "https://test-infolock.lockton.com";
                break;
            case "home-infolock.lockton.com":
                MVCLoginURL = "https://infolock.lockton.com";
                break;
            case "app-vhome-proddr-eastus2-01.azurewebsites.net":
                MVCLoginURL = "https://lbdp-proddr-vantage-app.azurewebsites.net";
                break;
            case "vantageuathorizonhome.exlservice.com":
                MVCLoginURL = "https://vantageuathorizon.exlservice.com";
                break;
            case "vantageprodhorizonhome.exlservice.com":
                MVCLoginURL = "https://vantageprodhorizon.exlservice.com";
                break;
            case "vantagetesthome.exlservice.com":
                MVCLoginURL = "https://vantagetest.exlservice.com/";
                break;
            case "vhomeexlnp3.triwest.com":
                MVCLoginURL = "vcoreexlnp3.triwest.com";
                break;
            case "vantagehome.triwest.com":
                MVCLoginURL = "vantage.triwest.com";
                break;
        }
        window.location.href = MVCLoginURL;
    }

    //remoteUrlWithVersionMA = "https://azvantagedev-ma.exlservice.com/remoteEntry.js";
    // remoteUrlWithVersionMA = "http://localhost:3001/remoteEntry.js";
    const script = document.createElement("script");
    script.src = remoteUrlWithVersionMA + "?v=19.4";
    script.onload = () => {
        // the injected script has loaded and is available on window
        // we can now resolve this Promise
        const proxy = {
            get: (request) => window.MA.get(request),
            init: (arg) => {
                try {
                    return window.MA.init(arg);
                } catch (e) {
                    console.log("remote container already initialized");
                }
            },
        };
        resolve(proxy);
    };
    script.onerror = () => {
        reject();
        //alert("Error loading " + this.src); // Error loading https://example.com/404.js
        // document.head.appendChild(null);
        //return null;
    };
    // inject this script with the src set to the versioned remoteEntry.js
    document.head.appendChild(script);
});